import { render, staticRenderFns } from "./AddressComments.vue?vue&type=template&id=7a0953dd&scoped=true"
import script from "./AddressComments.vue?vue&type=script&lang=js"
export * from "./AddressComments.vue?vue&type=script&lang=js"
import style0 from "./AddressComments.vue?vue&type=style&index=0&id=7a0953dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0953dd",
  null
  
)

export default component.exports